import script from "./InvitationRoutesTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./InvitationRoutesTable.vue?vue&type=script&lang=ts&setup=true"

import "./InvitationRoutesTable.vue?vue&type=style&index=0&id=3295de40&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3567651837/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3295de40"]])

export default __exports__